import AbstractRequestTask from "../AbstractRequestTask";
import Launcher from '../../apa/Launcher';

class NavExperienceTask extends AbstractRequestTask {

  constructor(version = 'v1') {
    super();
    this.version = version;
  }

  getHeaders() {
    const params = super.getParams();
    return {
      'Authorization': 'Bearer ' + params.user_token,
        // 'partition': 'claromexhomolog'
    };
}

  getParams() {
    const params = super.getParams();
    delete params.HKS;
    delete params.api_version;
    delete params.user_token;
    delete params.device_id;
    delete params.device_name;
    delete params.device_so;
    params.module_version= 'v2';

    // TODO:Pendientes por definicir como obtener el parametro faltante
    return  params;
  }


  getUrl() {
    const http = "http://";
    const url = Launcher.get("akamai_mfwk");
    return `${http}${url}/services/nav/v1/experience`;
  }

  success(data, b) {
    this.resolve(data);
  }
}

export default NavExperienceTask;


// WEBPACK FOOTER //
// ./src/requests/tasks/ads/NavExperienceTask.js